import { useEffect } from 'react';
import type { PropsWithChildren } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppNavbar from './components/Navbar';
import StagingBanner from './components/StagingBanner';
import ProductionBanner from './components/ProductionBanner';
// TODO: Implement Home page in the future
// import Home from './pages/Home';
import Explore from './pages/Explore';
// TODO: Implement About page in the future
import About from './pages/About';
import Team from './pages/Team';
// TODO: Implement Feedback page in the future
// import Feedback from './pages/Feedback';

import { useDataStore } from '@/store';

/**
 * Ensure bill and metric indexes are loaded before rendering its children.
 * Other pages (Home/About/etc.) render immediately.
 */
function BillIndexGate({ children }: PropsWithChildren) {
  const billIndexLoaded = useDataStore((s) => s.billIndexLoaded);
  const billIndexError = useDataStore((s) => s.billIndexError);
  const loadBillIndex = useDataStore((s) => s.loadBillIndex);

  const metricIndexLoaded = useDataStore((s) => s.metricIndexLoaded);
  const metricIndexError = useDataStore((s) => s.metricIndexError);
  const loadMetricIndex = useDataStore((s) => s.loadMetricIndex);

  useEffect(() => {
    if (!billIndexLoaded) void loadBillIndex();
    if (!metricIndexLoaded) void loadMetricIndex();
  }, [billIndexLoaded, loadBillIndex, metricIndexLoaded, loadMetricIndex]);

  if ((!billIndexLoaded && !billIndexError) || (!metricIndexLoaded && !metricIndexError)) {
    // Lightweight placeholder; can swap with Bootstrap spinner
    return (
      <div className="container py-4">
        <div className="text-muted">Loading catalogs…</div>
      </div>
    );
  }

  if (billIndexError || metricIndexError) {
    return (
      <div className="container py-4 text-danger">
        {billIndexError && <div>Failed to load bill catalog: {billIndexError}</div>}
        {metricIndexError && <div>Failed to load metric catalog: {metricIndexError}</div>}
      </div>
    );
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <>
      <StagingBanner />
      <ProductionBanner />
      <AppNavbar />

      <Routes>
        {/* Primary pages */}
        {/* Home route renders Explore */}
        <Route
          path="/"
          element={
            <BillIndexGate>
              <Explore />
            </BillIndexGate>
          }
        />
        {/* Keep /explore as an alias */}
        <Route
          path="/explore"
          element={
            <BillIndexGate>
              <Explore />
            </BillIndexGate>
          }
        />
        {/* TODO: Implement About page in the future */}
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        {/* TODO: Implement Feedback page in the future */}
        {/* <Route path="/feedback" element={<Feedback />} /> */}

        {/* Fallback: redirect anything else to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
